// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3r_BZ","alert":"SettungsInbox_alert__rPobc"};